var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGabon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0048 21.5878C31.648 19.8546 32 17.9798 32 16.0227C32 14.0655 31.648 12.1908 31.0048 10.4575L16 9.06615L0.995188 10.4575C0.352063 12.1908 0 14.0655 0 16.0227C0 17.9798 0.352063 19.8546 0.995188 21.5878L16 22.9792L31.0048 21.5878Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32.0225C22.8795 32.0225 28.7442 27.6805 31.0049 21.5877H0.995239C3.25599 27.6805 9.12061 32.0225 16.0001 32.0225Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 0.0224609C9.12061 0.0224609 3.25599 4.36446 0.995239 10.4573H31.0049C28.7442 4.36446 22.8795 0.0224609 16.0001 0.0224609Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGabon);
export default __webpack_public_path__ + "static/media/gabon.a7dd0766.svg";
export { ForwardRef as ReactComponent };